module.exports = __webpack_public_path__ + "static/media/facebook.3ae988fe.png";